import { Badge, Group, Radio, Stack, Text, TextInput } from '@mantine/core'

import { SinalWifi } from './SinalWifi'
import { AVISO_REDE_ABERTA, ehAberta, ordenarRedes, type RedeVista } from './redes'

/** A rede escolhida: uma da lista, ou a oculta, digitada. */
export type Escolha = { ssid: string; oculta: boolean }

const OCULTA = 'oculta'
// Prefixo no valor do rádio: um SSID pode ser qualquer texto, inclusive "oculta".
const valorDe = (ssid: string) => `rede:${ssid}`

/**
 * A lista que o rádio do robô enxergou, da mais forte à mais fraca, e a opção
 * de rede oculta por último. Comum à Frota e à USB.
 */
export function EscolherRede({
  redes, salvas, escolha, onChange, disabled = false,
}: {
  redes: readonly RedeVista[]
  /** SSIDs já gravados no robô. */
  salvas: ReadonlySet<string>
  escolha: Escolha
  onChange: (e: Escolha) => void
  disabled?: boolean
}) {
  const lista = ordenarRedes(redes)
  const valor = escolha.oculta ? OCULTA : escolha.ssid ? valorDe(escolha.ssid) : null
  return (
    <Stack gap="xs">
      <Radio.Group
        label="Rede Wi-Fi"
        description="As redes que o robô enxerga agora. Ele só opera em 2,4 GHz."
        value={valor}
        onChange={(v) => {
          if (v === OCULTA) onChange({ ssid: '', oculta: true })
          else onChange({ ssid: v.slice('rede:'.length), oculta: false })
        }}
      >
        <Stack gap={8} mt={6}>
          {lista.length === 0 && (
            <Text size="sm" c="dimmed">O robô não encontrou nenhuma rede compatível.</Text>
          )}
          {lista.map((r) => (
            <Radio
              key={r.ssid}
              value={valorDe(r.ssid)}
              disabled={disabled}
              label={
                <Stack gap={2}>
                  <Group gap="xs" wrap="wrap">
                    <Text size="sm" fw={500}>{r.ssid}</Text>
                    <SinalWifi rssi={r.rssi} />
                    {salvas.has(r.ssid) && <Badge size="sm" variant="light" color="inovareTeal">Já salva</Badge>}
                    {ehAberta(r.auth) && <Badge size="sm" variant="light" color="yellow">Aberta</Badge>}
                  </Group>
                  {ehAberta(r.auth) && <Text size="xs" c="dimmed">{AVISO_REDE_ABERTA}</Text>}
                </Stack>
              }
            />
          ))}
          <Radio value={OCULTA} disabled={disabled} label={<Text size="sm">Rede oculta (digitar o nome)</Text>} />
        </Stack>
      </Radio.Group>
      {escolha.oculta && (
        <TextInput
          label="Nome da rede oculta"
          value={escolha.ssid}
          onChange={(ev) => onChange({ ssid: ev.currentTarget.value, oculta: true })}
          disabled={disabled}
          autoComplete="off"
          w={260}
        />
      )}
    </Stack>
  )
}
